<template>
  <div v-if="loaded" class="row">
    <mh-input mhClass="col-12" labelColsLg="0" field="type" :table="indemnity"></mh-input>
    <mh-input
      mhClass="col-8"
      labelColsLg="0"
      field="montant"
      :table="indemnity"
      append="€"
    ></mh-input>
    <mh-input mhClass="col-4" labelColsLg="0" field="paye" :table="indemnity"></mh-input>
    <mh-input mhClass="col-12" labelColsLg="0" field="note" :table="indemnity"></mh-input>
    <b-col class="text-right mt-3">
      <b-button @click="$emit('close')">Annuler</b-button>
      <b-button @click="save" class="ml-3">Enregistrer</b-button>
    </b-col>
  </div>
</template>

<script>
import warrants from "@/services/warrants.js";
import MhInput from "@/components/MhInput.vue";
export default {
  name: "Indemnity",
  components: {
    MhInput,
  },
  props: {
    indemnity_id: [Number, String],
    warrant_id: [Number, String],
  },
  data() {
    return {
      indemnity: {},
      loaded: false,
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      warrants
        .indemnity({
          warrant_id: this.warrant_id,
          indemnity_id: this.indemnity_id,
        })
        .then((response) => {
          this.indemnity = response.data;
          this.loaded = true;
        });
    },
    
    save() {
      warrants.update_indemnity({
        warrant_id: this.warrant_id,
        indemnity_id: this.indemnity_id,
        indemnity: this.indemnity
      }).then(response => {
        if (response.data.success) {
          this.$bvToast.toast("Indemnité mise à jour", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 2000,
            solid: false,
          });
          for (let el in this.indemnity) {
            if (this.indemnity[el]) {
              this.indemnity[el].error = false;
            }
          }
          this.$emit('change');
          this.$emit('close');
        } else if (response.data.fail) {
          for (let el in this.indemnity) {
            if (this.indemnity[el]) {
              this.indemnity[el].error = false;
            }
          }
          response.data.fail.forEach((element) => {
            this.indemnity[element.field].error = element.errors.join(" ; ");
          });
        } else if (response.data.error) {
          this.$bvToast.toast("Erreur : " + response.data.error, {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "danger",
            autoHideDelay: 2000,
            solid: false,
          });
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
</style>